import React from 'react';

const Home = () => {
  return (
    <div style={{ marginTop: '50px' }}>
      <h1>Watchdog</h1><br />
      <br></br>
      <p>If you have any problem with functionality or some interesting suggestion for improvement of  this application do not hesitate and contact directly solution experts from Compensation Plans Team.</p>
      <p>Application is available only for <span style={{ color: "#E01A76" }}>authorized users</span>.</p>
    </div>
  );
}

export default Home;